import React from "react";
import "../App.css";

const DocumentList = () => {

  const documentos = [
    {
      titulo: "",
      imagen: "/imagenes/documentos/padem2024.jpg",
      pdf: "/pdfs/PADEM_2024.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/documentos/proyectoeducativo.jpg",
      pdf: "/pdfs/Proyecto Educativo.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/documentos/reglamentoevaluacion.jpg",
      pdf: "/pdfs/REGLAMENTO DE EVALUACIÓN 2023.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/documentos/rice.jpg",
      pdf: "/pdfs/RICE ACTUALIZADO 2026 10-06.pdf",
    },
    {
      titulo: "",
      imagen: "/imagenes/documentos/protocolocelulares.jpg",
      pdf: "/pdfs/Protocolo escolar.pdf",
    },
  ];

  return (
    <div id="documentos" className="cursos-container">

      <h2 className="junaeb-title">
        Documentos Institucionales
      </h2>

      <div className="cards-grid">

        {documentos.map((doc, index) => (

          <a
            key={index}
            href={doc.pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="card-link"
          >

            <div className="pdf-card">

              <img
                src={doc.imagen}
                alt={doc.titulo}
                className="pdf-image"
              />

              <div className="pdf-title">
                {doc.titulo}
              </div>

            </div>

          </a>

        ))}

      </div>

    </div>
  );
};

export default DocumentList;
